module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin"
  }, [_c('Loader', {
    attrs: {
      "loading": _vm.loader,
      "fixed": true
    }
  }), _vm._v(" "), (_vm.user) ? _c('p', {
    staticClass: "admin-user-title"
  }, [_vm._v(_vm._s(_vm.user.firstname.toUpperCase()) + " " + _vm._s(_vm.user.lastname.toUpperCase()))]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "admin-user"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-10"
  }, [_c('div', {
    staticClass: "admin-user-infos table-responsive"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("createUser.labelEmail")) + ":")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("userList.lastConnection")) + " :")]), _vm._v(" "), _c('td', [(_vm.user.lastConnectionDate) ? [_vm._v("\n                                    " + _vm._s(_vm.getDateByFormat(_vm.user.lastConnectionDate, "DD/MM/YYYY HH:mm")) + "\n                                ")] : [_vm._v("-")]], 2)])])]), _vm._v(" "), (_vm.userBrandsFiltered.length) ? _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12 col-md"
  }, [_c('p', {
    staticClass: "messageAccessBrand mb-4"
  }, [_vm._v(_vm._s(_vm.$t("userrole.messageAccessBrand")))]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex flex-row justify-content-center justify-content-sm-start"
  }, _vm._l((_vm.userBrandsFiltered), function(userBrand, key) {
    return ((_vm.isSuperAdmin() || _vm.isClientAdmin(userBrand.brand.id)) && userBrand.brand.id !== _vm.currentBrand.id) ? _c('div', {
      key: key,
      staticClass: "px-4 pb-3",
      staticStyle: {
        "flex-basis": "250px",
        "flex-grow": "0"
      }
    }, [_c('ClientColorButton', {
      attrs: {
        "background-color": "#727a96",
        "width": "100%"
      },
      on: {
        "click": function($event) {
          _vm.changeBrand(userBrand.brand)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(userBrand.brand.name) + "\n                                ")])], 1) : _vm._e()
  }))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-2 d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-center flex-column",
    staticStyle: {
      "flex": "1 1 auto"
    }
  }, [_c('ClientColorButton', {
    staticClass: "mb-4 w-100",
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.openModalEditUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("userAdmin.edit_info")))]), _vm._v(" "), _c('ClientColorButton', {
    staticClass: "mb-4 w-100",
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.openModalDeleteBrand()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("userAdmin.delete_from_brand")))]), _vm._v(" "), (_vm.isSuperAdmin()) ? _c('ClientColorButton', {
    staticClass: "w-100 mb-4",
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.openModalChangeAccess()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.user.isEnabled ? "userAdmin.disable_user" : "userAdmin.enable_user")))]) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin()) ? [(!_vm.user.isSsoEnabled) ? _c('ClientColorButton', {
    staticClass: "mb-4 w-100",
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": function($event) {
        _vm.resetLoginAttempts(_vm.user.id)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("plano.buttonLoginAttempts")) + "\n                        ")]) : _c('ClientColorButton', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: ('SSO mode enable for this user, this action is forbidden'),
      expression: "'SSO mode enable for this user, this action is forbidden'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "mb-4 w-100",
    attrs: {
      "inactive-color": true
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("plano.buttonLoginAttempts")) + "\n                        ")])] : _vm._e(), _vm._v(" "), (_vm.modalParamsDeleteBrand) ? _c('DeleteBrand', {
    attrs: {
      "params": _vm.modalParamsDeleteBrand
    },
    on: {
      "loadUsers": function($event) {
        _vm.close()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalParamsChangeAccess) ? _c('ChangeAccess', {
    attrs: {
      "params": _vm.modalParamsChangeAccess
    },
    on: {
      "loadUsers": function($event) {
        _vm.getInfosUser(true)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user && _vm.modalParamsEditUser) ? _c('UserEdit', {
    attrs: {
      "params": _vm.modalParamsEditUser
    },
    on: {
      "reload": function($event) {
        _vm.getInfosUser(true)
      }
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('History', {
    attrs: {
      "object": _vm.user,
      "object-type": _vm.OBJECT_TYPE.USERS,
      "is-dark": false,
      "is-grey": true
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.getBrandAccess && _vm.getBrandAccess.length && _vm.brandAccessFiltered.length && _vm.user) ? _c('div', {
    staticClass: "admin-role mt-5"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "admin-role-title"
  }, [_vm._v(_vm._s(_vm.$t("userrole.rights")) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [(_vm.brandZonesFiltered.length) ? _c('ClientColorButton', {
    attrs: {
      "color": _vm.currentBrand.colorLinks
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.user.userType === 0) ? _c('div', {
    staticClass: "d-flex align-items-center my-4 admin-role-switch-client-admin"
  }, [_c('span', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$t("userrole.isSuperAdmin")))]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-m",
    attrs: {
      "for": "switchSuperAdmin",
      "id": "'tooltipSuperAdmin'"
    }
  }, [(_vm.isSuperAdmin()) ? _c('input', {
    attrs: {
      "type": "checkbox",
      "id": "switchSuperAdmin"
    },
    domProps: {
      "checked": _vm.user.isSuperAdmin
    },
    on: {
      "input": function($event) {
        _vm.changeSuperAdmin($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "slider round",
    style: ({
      'background-color': _vm.user.isSuperAdmin ? _vm.currentBrand.linksColor : ''
    })
  })]), _vm._v(" "), (!_vm.isSuperAdmin()) ? _c('b-tooltip', {
    attrs: {
      "target": "tooltipSuperAdmin",
      "placement": "right"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userrole.noRight")))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.user.userType === 1 && _vm.isSuperAdmin()) ? _c('div', {
    staticClass: "d-flex align-items-center my-4 admin-role-switch-client-admin"
  }, [_c('span', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$t("userrole.isClientAdmin")))]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-m",
    attrs: {
      "for": "switchClientAdmin",
      "id": "tooltipClientAdmin"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "switchClientAdmin",
      "disabled": !(_vm.isSuperAdmin() || _vm.isClientAdmin())
    },
    domProps: {
      "checked": _vm.isUserClientAdmin
    },
    on: {
      "input": function($event) {
        _vm.changeClientAdmin($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round",
    style: ({
      'background-color': _vm.isUserClientAdmin ? _vm.currentBrand.linksColor : ''
    })
  })]), _vm._v(" "), (!(_vm.isSuperAdmin() || _vm.isClientAdmin())) ? _c('b-tooltip', {
    attrs: {
      "target": "tooltipClientAdmin",
      "placement": "right"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("userrole.noRight")))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isSuperAdmin) ? _c('div', [_c('b-tabs', {
    attrs: {
      "content-class": "mt-3"
    }
  }, _vm._l((_vm.brandAccessFiltered), function(brandAccess, key) {
    return (_vm.displayTab(brandAccess.application)) ? _c('b-tab', {
      key: key,
      attrs: {
        "title": _vm.getTranslate(brandAccess.terms.name),
        "active": _vm.rightsUserTab ? key === parseInt(_vm.rightsUserTab, 10) : key === 0
      },
      on: {
        "click": function($event) {
          _vm.changeApp(brandAccess, key)
        }
      }
    }, [_c('div', {
      staticClass: "row mt-4"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.search),
        expression: "search"
      }],
      staticClass: "rem3rch-input-text",
      attrs: {
        "type": "text",
        "id": "searchBySearch"
      },
      domProps: {
        "value": (_vm.search)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.search = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "m-0 pointer ml-3",
      attrs: {
        "for": "searchBySearch"
      }
    }, [_c('i', {
      staticClass: "fa fa-search fa-lg color-grey"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "table-responsive-old"
    }, [_c('table', {
      staticClass: "admin-role-table"
    }, [_c('thead', [_c('tr', [_c('th', {
      attrs: {
        "colspan": "5"
      }
    }, [_c('div', {
      staticClass: "row d-flex align-items-center"
    }, [_c('div', {
      staticClass: "col-auto"
    }, [_c('ClientColorButton', {
      staticClass: "mt-4",
      attrs: {
        "inactive-color": true
      },
      on: {
        "click": function($event) {
          _vm.selectAll()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.selectAll")))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-auto"
    }, [_c('ClientColorButton', {
      staticClass: "mt-4",
      attrs: {
        "inactive-color": true
      },
      on: {
        "click": function($event) {
          _vm.selectNone()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.selectNone")))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-auto"
    }, [_c('ClientColorButton', {
      staticClass: "mt-4",
      attrs: {
        "inactive-color": true
      },
      on: {
        "click": function($event) {
          _vm.resetSelectedProfiles()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("common.resetSelection")))])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-auto d-flex admin-role-filter mt-4"
    }, [_c('Multiselect', {
      staticClass: "mr-5",
      attrs: {
        "options": _vm.profiles,
        "label": 'name',
        "track-by": "name",
        "multiple": false,
        "select-label": '',
        "searchable": false,
        "close-on-select": true,
        "show-labels": true,
        "placeholder": _vm.$t('userrole.filterProfile'),
        "deselect-label": _vm.$t('common.delete')
      },
      model: {
        value: (_vm.filteredProfile),
        callback: function($$v) {
          _vm.filteredProfile = $$v
        },
        expression: "filteredProfile"
      }
    }), _vm._v(" "), _c('Multiselect', {
      attrs: {
        "options": _vm.zoneGroups,
        "label": 'name',
        "track-by": "name",
        "multiple": false,
        "select-label": '',
        "searchable": false,
        "close-on-select": true,
        "show-labels": true,
        "placeholder": _vm.$t('userrole.filterGroup'),
        "deselect-label": _vm.$t('common.delete')
      },
      model: {
        value: (_vm.filteredGroup),
        callback: function($$v) {
          _vm.filteredGroup = $$v
        },
        expression: "filteredGroup"
      }
    })], 1)])]), _vm._v(" "), _c('th', {
      staticClass: "header-profile admin-role-filter mt-4"
    }, [(_vm.checkedZones.length > 0) ? _c('Multiselect', {
      attrs: {
        "options": _vm.profilesFiltered,
        "label": 'name',
        "track-by": "name",
        "multiple": false,
        "select-label": '',
        "searchable": false,
        "close-on-select": true,
        "show-labels": true,
        "placeholder": _vm.$t('userrole.selectProfile'),
        "deselect-label": _vm.$t('common.delete')
      },
      on: {
        "input": function($event) {
          _vm.updateCheckedZonesProfile(_vm.multiProfileUpdate)
        }
      },
      model: {
        value: (_vm.multiProfileUpdate),
        callback: function($$v) {
          _vm.multiProfileUpdate = $$v
        },
        expression: "multiProfileUpdate"
      }
    }) : _vm._e()], 1)])]), _vm._v(" "), (!_vm.changingTab) ? _c('tbody', _vm._l((_vm.brandZonesFiltered), function(brandZone, key) {
      return _c('tr', {
        key: key
      }, [_c('td', {
        staticClass: "color",
        style: ({
          backgroundColor: _vm.getProfileColor(brandZone.zone.id)
        })
      }), _vm._v(" "), _c('td', {
        staticClass: "checkbox"
      }, [(_vm.profileCanBeUpdated(_vm.seletedProfileByZone[brandZone.zone.id])) ? [_c('label', {
        staticClass: "label-checkbox pointer mb-0 d-flex align-items-center justify-content-center",
        attrs: {
          "for": 'checkbox_zone_' + brandZone.zone.id
        }
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.checkedZones.includes(brandZone.zone.id)),
          expression: "checkedZones.includes(brandZone.zone.id)"
        }],
        staticClass: "rem3rch-checkbox rem3rch-checkbox",
        on: {
          "click": function($event) {
            _vm.checkZone(brandZone.zone.id, false)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-check"
      })]), _vm._v(" "), (!_vm.checkedZones.includes(brandZone.zone.id)) ? _c('span', {
        staticClass: "rem3rch-checkbox rem3rch-checkbox",
        on: {
          "click": function($event) {
            _vm.checkZone(brandZone.zone.id, true)
          }
        }
      }) : _vm._e()])] : _vm._e()], 2), _vm._v(" "), _c('td', {
        staticClass: "ref"
      }, [_vm._v(_vm._s(brandZone.zone.refClient))]), _vm._v(" "), _c('td', {
        staticClass: "name"
      }, [_vm._v(_vm._s(brandZone.zone.name))]), _vm._v(" "), _c('td', {
        staticClass: "zoneGroup"
      }, [(_vm.getBrandZone(brandZone.zone.id) && brandZone.zoneGroupsRights) ? [_vm._v("\n                                                    " + _vm._s(brandZone.zoneGroupsRights.name) + "\n                                                ")] : _vm._e()], 2), _vm._v(" "), _c('td', {
        staticClass: "profile"
      }, [_c('Multiselect', {
        attrs: {
          "options": _vm.profilesFiltered,
          "label": 'name',
          "track-by": "name",
          "multiple": false,
          "select-label": '',
          "searchable": false,
          "close-on-select": true,
          "show-labels": true,
          "placeholder": _vm.$t('userrole.selectProfile'),
          "deselect-label": _vm.$t('common.delete'),
          "disabled": !_vm.profileCanBeUpdated(_vm.seletedProfileByZone[brandZone.zone.id])
        },
        model: {
          value: (_vm.seletedProfileByZone[brandZone.zone.id]),
          callback: function($$v) {
            _vm.$set(_vm.seletedProfileByZone, brandZone.zone.id, $$v)
          },
          expression: "seletedProfileByZone[brandZone.zone.id]"
        }
      })], 1), _vm._v(" "), _c('td', {
        staticClass: "view-zone text-center"
      }, [_c('ClientColorButton', {
        attrs: {
          "inactive-color": true
        },
        on: {
          "click": function($event) {
            _vm.$router.push({
              path: '/zones/zone/' + brandZone.zone.id
            })
          }
        }
      }, [_vm._v(_vm._s(_vm.$t("userrole.viewZone")))])], 1)])
    })) : _vm._e()]), _vm._v(" "), (!_vm.brandZonesFiltered.length) ? _c('div', {
      staticClass: "d-flex align-items-center justify-content-center notfound"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t("zonerole.notfound")))])]) : _vm._e()])])])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center mt-4"
  }, [_c('ClientColorButton', {
    staticClass: "mr-3",
    attrs: {
      "inactive-color": true
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), (_vm.brandZonesFiltered.length) ? _c('ClientColorButton', {
    attrs: {
      "color": _vm.currentBrand.colorLinks
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("common.save")))]) : _vm._e()], 1)], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cebdfcb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/user/UserRole.vue
// module id = 3056
// module chunks = 0